import React from "react";

import {
  IAvatar,
  ISeasonLocationAvatarItem,
  ISeasonLocationAvatarItemGroup,
} from "lib/types";
import { SeasonLocation } from "sharedComponents/molecules/SeasonLocation";
import { CombinedItem } from "sharedComponents/molecules/SeasonLocationProgress";

import AClassicCaperSVG from "./resource/a_classic_caper.svg";
import CurseOfTheForgottonForestSVG from "./resource/curse_of_the_forgotten_forest.svg";
import DriveToWinSVG from "./resource/drive_to_win.svg";
import MechsVsMonstersSVG from "./resource/mechs_vs_monsters.svg";
import StreamerStudioSVG from "./resource/streamer_studio.svg";
import XplosionSVG from "./resource/xplosion.svg";

export interface ISeason4LocationProps {
  width: number;
  height: number;
  canUnlock: boolean;
  avatarItems: Array<ISeasonLocationAvatarItem>;
  avatarItemGroups: Array<ISeasonLocationAvatarItemGroup>;
  locationId: string;
  pathColor: string;
  isLoading: boolean;
  avatarAtlasUrl: string;
  avatarSkeletonUrl: string;
  avatar: IAvatar;
  handleRequestUnlock?: (item: CombinedItem) => void;
}

const locationToBGMap: { [locationId: string]: string } = {
  31: XplosionSVG,
  32: AClassicCaperSVG,
  33: CurseOfTheForgottonForestSVG,
  34: DriveToWinSVG,
  35: MechsVsMonstersSVG,
  36: StreamerStudioSVG,
};

export const Season4Location: React.FC<ISeason4LocationProps> = ({
  width,
  height,
  avatarItems,
  avatarItemGroups,
  locationId,
  pathColor,
  isLoading,
  avatarAtlasUrl,
  avatarSkeletonUrl,
  handleRequestUnlock,
  canUnlock,
  avatar,
}) => {
  return (
    <SeasonLocation
      width={width}
      height={height}
      canUnlock={canUnlock}
      avatarAtlasUrl={avatarAtlasUrl}
      avatarSkeletonUrl={avatarSkeletonUrl}
      handleRequestUnlock={handleRequestUnlock}
      avatarItems={avatarItems}
      avatarItemGroups={avatarItemGroups}
      pathColor={pathColor}
      isLoading={isLoading}
      avatar={avatar}
      bgSVG={locationToBGMap[locationId]}
      avatarScaleConstant={3000}
      avatarOffsetYRatioConstant={0.26}
      roadColor="#102421"
    />
  );
};
